import React, { useState } from 'react';
import { MessageSquare, Mail, Phone, Video, Calendar, Clock, BarChart2, Settings, Inbox, Send, Users, PlusCircle, Search, ChevronDown, Filter, MoreHorizontal } from 'lucide-react';
export const CommunicationCentral = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedChannel, setSelectedChannel] = useState('all');
  return <div className="container mx-auto" data-id="element-760">
      <div className="mb-6" data-id="element-761">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-762">
          Communication Central
        </h1>
        <p className="text-gray-600" data-id="element-763">
          Manage all candidate communications across multiple channels
        </p>
      </div>
      <div className="bg-white rounded-lg shadow" data-id="element-764">
        <div className="border-b border-gray-200" data-id="element-765">
          <div className="flex flex-wrap" data-id="element-766">
            <button onClick={() => setActiveTab('overview')} className={`px-6 py-4 text-sm font-medium ${activeTab === 'overview' ? 'border-b-2 border-indigo-600 text-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-767">
              Overview
            </button>
            <button onClick={() => setActiveTab('inbox')} className={`px-6 py-4 text-sm font-medium ${activeTab === 'inbox' ? 'border-b-2 border-indigo-600 text-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-768">
              Inbox
            </button>
            <button onClick={() => setActiveTab('campaigns')} className={`px-6 py-4 text-sm font-medium ${activeTab === 'campaigns' ? 'border-b-2 border-indigo-600 text-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-769">
              Campaigns
            </button>
            <button onClick={() => setActiveTab('templates')} className={`px-6 py-4 text-sm font-medium ${activeTab === 'templates' ? 'border-b-2 border-indigo-600 text-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-770">
              Templates
            </button>
            <button onClick={() => setActiveTab('analytics')} className={`px-6 py-4 text-sm font-medium ${activeTab === 'analytics' ? 'border-b-2 border-indigo-600 text-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-771">
              Analytics
            </button>
            <button onClick={() => setActiveTab('settings')} className={`px-6 py-4 text-sm font-medium ${activeTab === 'settings' ? 'border-b-2 border-indigo-600 text-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-772">
              Settings
            </button>
          </div>
        </div>
        {activeTab === 'overview' && <div className="p-6" data-id="element-773">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-774">
              <ChannelCard icon={<Mail size={24} className="text-indigo-600" data-id="element-776" />} title="Email" stats={{
            sent: 1243,
            opened: 876,
            rate: 70.5
          }} selected={selectedChannel === 'email'} onClick={() => setSelectedChannel('email')} data-id="element-775" />
              <ChannelCard icon={<MessageSquare size={24} className="text-indigo-600" data-id="element-778" />} title="SMS" stats={{
            sent: 758,
            opened: 721,
            rate: 95.1
          }} selected={selectedChannel === 'sms'} onClick={() => setSelectedChannel('sms')} data-id="element-777" />
              <ChannelCard icon={<Phone size={24} className="text-indigo-600" data-id="element-780" />} title="Voice" stats={{
            sent: 412,
            opened: 382,
            rate: 92.7
          }} selected={selectedChannel === 'voice'} onClick={() => setSelectedChannel('voice')} data-id="element-779" />
              <ChannelCard icon={<Video size={24} className="text-indigo-600" data-id="element-782" />} title="Video" stats={{
            sent: 128,
            opened: 98,
            rate: 76.6
          }} selected={selectedChannel === 'video'} onClick={() => setSelectedChannel('video')} data-id="element-781" />
            </div>
            <div className="mb-8" data-id="element-783">
              <div className="flex justify-between items-center mb-4" data-id="element-784">
                <h2 className="text-lg font-medium" data-id="element-785">Recent Communications</h2>
                <div className="flex items-center" data-id="element-786">
                  <div className="relative mr-4" data-id="element-787">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-788">
                      <Search size={16} className="text-gray-400" data-id="element-789" />
                    </div>
                    <input type="text" className="pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:border-indigo-500 sm:text-sm" placeholder="Search communications..." data-id="element-790" />
                  </div>
                  <button className="flex items-center px-3 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-791">
                    <Filter size={16} className="mr-1" data-id="element-792" />
                    Filter
                    <ChevronDown size={16} className="ml-1" data-id="element-793" />
                  </button>
                </div>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-794">
                <table className="min-w-full divide-y divide-gray-200" data-id="element-795">
                  <thead className="bg-gray-50" data-id="element-796">
                    <tr data-id="element-797">
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-798">
                        Candidate
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-799">
                        Channel
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-800">
                        Subject/Content
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-801">
                        Status
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-802">
                        Date
                      </th>
                      <th scope="col" className="relative px-6 py-3" data-id="element-803">
                        <span className="sr-only" data-id="element-804">Actions</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200" data-id="element-805">
                    {[{
                  candidate: 'Sarah Johnson',
                  channel: 'email',
                  subject: 'Interview Confirmation',
                  status: 'Opened',
                  date: '2 hours ago'
                }, {
                  candidate: 'Michael Brown',
                  channel: 'sms',
                  subject: 'Reminder: Your interview is tomorrow',
                  status: 'Delivered',
                  date: '5 hours ago'
                }, {
                  candidate: 'Emily Davis',
                  channel: 'voice',
                  subject: 'Initial screening call',
                  status: 'Completed',
                  date: 'Yesterday'
                }, {
                  candidate: 'Robert Wilson',
                  channel: 'email',
                  subject: 'Follow-up on your application',
                  status: 'Not opened',
                  date: '2 days ago'
                }, {
                  candidate: 'Jennifer Lee',
                  channel: 'video',
                  subject: 'Technical interview',
                  status: 'Scheduled',
                  date: 'Tomorrow'
                }].map((comm, index) => <tr key={index} data-id="element-806">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-807">
                          <div className="flex items-center" data-id="element-808">
                            <div className="h-10 w-10 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-medium" data-id="element-809">
                              {comm.candidate.charAt(0)}
                            </div>
                            <div className="ml-4" data-id="element-810">
                              <div className="text-sm font-medium text-gray-900" data-id="element-811">
                                {comm.candidate}
                              </div>
                              <div className="text-sm text-gray-500" data-id="element-812">
                                Software Engineer
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-813">
                          <div className="flex items-center" data-id="element-814">
                            {comm.channel === 'email' && <Mail size={16} className="text-indigo-600 mr-2" data-id="element-815" />}
                            {comm.channel === 'sms' && <MessageSquare size={16} className="text-green-600 mr-2" data-id="element-816" />}
                            {comm.channel === 'voice' && <Phone size={16} className="text-blue-600 mr-2" data-id="element-817" />}
                            {comm.channel === 'video' && <Video size={16} className="text-purple-600 mr-2" data-id="element-818" />}
                            <span className="capitalize" data-id="element-819">{comm.channel}</span>
                          </div>
                        </td>
                        <td className="px-6 py-4" data-id="element-820">
                          <div className="text-sm text-gray-900 truncate max-w-xs" data-id="element-821">
                            {comm.subject}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-822">
                          <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
                            ${comm.status === 'Opened' || comm.status === 'Completed' ? 'bg-green-100 text-green-800' : comm.status === 'Delivered' ? 'bg-blue-100 text-blue-800' : comm.status === 'Scheduled' ? 'bg-purple-100 text-purple-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-823">
                            {comm.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-824">
                          {comm.date}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-825">
                          <button className="text-indigo-600 hover:text-indigo-900" data-id="element-826">
                            View
                          </button>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-827">
              <div className="lg:col-span-2" data-id="element-828">
                <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-829">
                  <h3 className="text-lg font-medium mb-4" data-id="element-830">
                    Communication Analytics
                  </h3>
                  <div className="h-64 bg-gray-50 rounded-lg flex items-center justify-center" data-id="element-831">
                    <p className="text-gray-500" data-id="element-832">
                      Communication trends chart will appear here
                    </p>
                  </div>
                  <div className="grid grid-cols-3 gap-4 mt-6" data-id="element-833">
                    <div className="bg-indigo-50 p-4 rounded-lg" data-id="element-834">
                      <div className="text-sm text-indigo-600 mb-1" data-id="element-835">
                        Response Rate
                      </div>
                      <div className="text-2xl font-bold" data-id="element-836">76%</div>
                      <div className="text-xs text-indigo-500" data-id="element-837">
                        +5% from last month
                      </div>
                    </div>
                    <div className="bg-green-50 p-4 rounded-lg" data-id="element-838">
                      <div className="text-sm text-green-600 mb-1" data-id="element-839">
                        Avg. Response Time
                      </div>
                      <div className="text-2xl font-bold" data-id="element-840">4.2h</div>
                      <div className="text-xs text-green-500" data-id="element-841">
                        -1.5h from last month
                      </div>
                    </div>
                    <div className="bg-purple-50 p-4 rounded-lg" data-id="element-842">
                      <div className="text-sm text-purple-600 mb-1" data-id="element-843">
                        Engagement Score
                      </div>
                      <div className="text-2xl font-bold" data-id="element-844">8.4/10</div>
                      <div className="text-xs text-purple-500" data-id="element-845">
                        +0.6 from last month
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div data-id="element-846">
                <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-847">
                  <div className="flex justify-between items-center mb-4" data-id="element-848">
                    <h3 className="text-lg font-medium" data-id="element-849">Upcoming Scheduled</h3>
                    <button className="text-sm text-indigo-600 hover:text-indigo-800" data-id="element-850">
                      View All
                    </button>
                  </div>
                  <div className="space-y-4" data-id="element-851">
                    {[{
                  candidate: 'Jennifer Lee',
                  type: 'Video Interview',
                  time: 'Today, 2:30 PM',
                  icon: <Video size={16} className="text-purple-600" data-id="element-852" />
                }, {
                  candidate: 'David Miller',
                  type: 'Phone Screening',
                  time: 'Today, 4:15 PM',
                  icon: <Phone size={16} className="text-blue-600" data-id="element-853" />
                }, {
                  candidate: 'Alex Thompson',
                  type: 'Email Follow-up',
                  time: 'Tomorrow, 10:00 AM',
                  icon: <Mail size={16} className="text-indigo-600" data-id="element-854" />
                }].map((event, index) => <div key={index} className="flex items-start p-3 border border-gray-200 rounded-lg" data-id="element-855">
                        <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-856">
                          {event.icon}
                        </div>
                        <div data-id="element-857">
                          <p className="font-medium" data-id="element-858">{event.candidate}</p>
                          <p className="text-sm text-gray-500" data-id="element-859">{event.type}</p>
                          <p className="text-xs text-gray-500 mt-1" data-id="element-860">
                            {event.time}
                          </p>
                        </div>
                      </div>)}
                  </div>
                  <button className="w-full mt-4 py-2 border border-dashed border-gray-300 rounded-lg text-indigo-600 hover:bg-indigo-50 transition-colors flex items-center justify-center" data-id="element-861">
                    <PlusCircle size={16} className="mr-1" data-id="element-862" />
                    Schedule Communication
                  </button>
                </div>
              </div>
            </div>
          </div>}
        {activeTab === 'inbox' && <div className="p-6" data-id="element-863">
            <div className="flex justify-between items-center mb-6" data-id="element-864">
              <div data-id="element-865">
                <h2 className="text-lg font-medium" data-id="element-866">Unified Inbox</h2>
                <p className="text-sm text-gray-500" data-id="element-867">
                  View and respond to all communications in one place
                </p>
              </div>
              <div className="flex items-center" data-id="element-868">
                <div className="relative mr-4" data-id="element-869">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-870">
                    <Search size={16} className="text-gray-400" data-id="element-871" />
                  </div>
                  <input type="text" className="pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:border-indigo-500 sm:text-sm" placeholder="Search messages..." data-id="element-872" />
                </div>
                <button className="flex items-center px-3 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-873">
                  <Filter size={16} className="mr-1" data-id="element-874" />
                  Filter
                </button>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-875">
              <div className="lg:col-span-1 border border-gray-200 rounded-lg overflow-hidden" data-id="element-876">
                <div className="p-4 bg-gray-50 border-b border-gray-200 flex justify-between items-center" data-id="element-877">
                  <h3 className="font-medium" data-id="element-878">Conversations</h3>
                  <button className="text-indigo-600 hover:text-indigo-800" data-id="element-879">
                    <PlusCircle size={16} data-id="element-880" />
                  </button>
                </div>
                <div className="overflow-y-auto" style={{
              maxHeight: '600px'
            }} data-id="element-881">
                  {[{
                name: 'Sarah Johnson',
                lastMessage: 'Thank you for the interview opportunity...',
                time: '10:30 AM',
                unread: true,
                channel: 'email'
              }, {
                name: 'Michael Brown',
                lastMessage: 'Yes, I can make it to the interview tomorrow at 2 PM.',
                time: 'Yesterday',
                unread: false,
                channel: 'sms'
              }, {
                name: 'Emily Davis',
                lastMessage: 'Call completed: 15 minutes',
                time: 'Yesterday',
                unread: false,
                channel: 'voice'
              }, {
                name: 'Robert Wilson',
                lastMessage: 'I have attached my updated resume as requested.',
                time: '2 days ago',
                unread: false,
                channel: 'email'
              }, {
                name: 'Jennifer Lee',
                lastMessage: 'Video interview scheduled for tomorrow at 3:30 PM.',
                time: '3 days ago',
                unread: false,
                channel: 'video'
              }].map((conversation, index) => <div key={index} className={`p-4 border-b border-gray-200 cursor-pointer hover:bg-gray-50 ${index === 0 ? 'bg-indigo-50' : ''}`} data-id="element-882">
                      <div className="flex items-start" data-id="element-883">
                        <div className="h-10 w-10 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-medium mr-3" data-id="element-884">
                          {conversation.name.charAt(0)}
                        </div>
                        <div className="flex-1 min-w-0" data-id="element-885">
                          <div className="flex justify-between items-center" data-id="element-886">
                            <p className={`text-sm font-medium ${conversation.unread ? 'text-indigo-600' : 'text-gray-900'}`} data-id="element-887">
                              {conversation.name}
                            </p>
                            <div className="flex items-center" data-id="element-888">
                              {conversation.channel === 'email' && <Mail size={12} className="text-gray-400 mr-1" data-id="element-889" />}
                              {conversation.channel === 'sms' && <MessageSquare size={12} className="text-gray-400 mr-1" data-id="element-890" />}
                              {conversation.channel === 'voice' && <Phone size={12} className="text-gray-400 mr-1" data-id="element-891" />}
                              {conversation.channel === 'video' && <Video size={12} className="text-gray-400 mr-1" data-id="element-892" />}
                              <p className="text-xs text-gray-500" data-id="element-893">
                                {conversation.time}
                              </p>
                            </div>
                          </div>
                          <p className="text-sm text-gray-500 truncate" data-id="element-894">
                            {conversation.lastMessage}
                          </p>
                          {conversation.unread && <span className="inline-block w-2 h-2 bg-indigo-600 rounded-full mt-1" data-id="element-895"></span>}
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>
              <div className="lg:col-span-2 border border-gray-200 rounded-lg overflow-hidden" data-id="element-896">
                <div className="p-4 bg-gray-50 border-b border-gray-200 flex justify-between items-center" data-id="element-897">
                  <div className="flex items-center" data-id="element-898">
                    <div className="h-10 w-10 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-medium mr-3" data-id="element-899">
                      S
                    </div>
                    <div data-id="element-900">
                      <p className="font-medium" data-id="element-901">Sarah Johnson</p>
                      <div className="flex items-center text-xs text-gray-500" data-id="element-902">
                        <Mail size={12} className="mr-1" data-id="element-903" />
                        <span data-id="element-904">via Email • Software Engineer Candidate</span>
                      </div>
                    </div>
                  </div>
                  <div data-id="element-905">
                    <button className="text-gray-500 hover:text-gray-700" data-id="element-906">
                      <MoreHorizontal size={16} data-id="element-907" />
                    </button>
                  </div>
                </div>
                <div className="p-4 overflow-y-auto bg-gray-50" style={{
              height: '400px'
            }} data-id="element-908">
                  <div className="space-y-4" data-id="element-909">
                    <div className="flex justify-end" data-id="element-910">
                      <div className="bg-indigo-100 text-indigo-800 p-3 rounded-lg max-w-md" data-id="element-911">
                        <p className="text-sm" data-id="element-912">
                          Hello Sarah, thank you for your application for the
                          Software Engineer position. We'd like to schedule an
                          initial screening call with you. Are you available
                          this week?
                        </p>
                        <p className="text-xs text-right mt-1 text-indigo-600" data-id="element-913">
                          10:15 AM • Sent by AI Recruiter
                        </p>
                      </div>
                    </div>
                    <div className="flex" data-id="element-914">
                      <div className="bg-white border border-gray-200 p-3 rounded-lg max-w-md" data-id="element-915">
                        <p className="text-sm" data-id="element-916">
                          Hi, thank you for reaching out! Yes, I'm available
                          this week. I could do Wednesday or Thursday afternoon,
                          if that works for you.
                        </p>
                        <p className="text-xs text-right mt-1 text-gray-500" data-id="element-917">
                          10:22 AM
                        </p>
                      </div>
                    </div>
                    <div className="flex justify-end" data-id="element-918">
                      <div className="bg-indigo-100 text-indigo-800 p-3 rounded-lg max-w-md" data-id="element-919">
                        <p className="text-sm" data-id="element-920">
                          Great! Would Thursday at 2:30 PM (PST) work for you?
                          The call will be approximately 30 minutes.
                        </p>
                        <p className="text-xs text-right mt-1 text-indigo-600" data-id="element-921">
                          10:28 AM • Sent by AI Recruiter
                        </p>
                      </div>
                    </div>
                    <div className="flex" data-id="element-922">
                      <div className="bg-white border border-gray-200 p-3 rounded-lg max-w-md" data-id="element-923">
                        <p className="text-sm" data-id="element-924">
                          Thursday at 2:30 PM PST works perfectly for me. Should
                          I expect a phone call or will this be a video
                          interview?
                        </p>
                        <p className="text-xs text-right mt-1 text-gray-500" data-id="element-925">
                          10:30 AM
                        </p>
                      </div>
                    </div>
                    <div className="flex justify-end" data-id="element-926">
                      <div className="bg-indigo-100 text-indigo-800 p-3 rounded-lg max-w-md" data-id="element-927">
                        <p className="text-sm" data-id="element-928">
                          This will be a phone call. I'll call you at the number
                          you provided in your application. I've sent a calendar
                          invitation to your email as well. Looking forward to
                          speaking with you!
                        </p>
                        <p className="text-xs text-right mt-1 text-indigo-600" data-id="element-929">
                          10:32 AM • Sent by AI Recruiter
                        </p>
                      </div>
                    </div>
                    <div className="flex" data-id="element-930">
                      <div className="bg-white border border-gray-200 p-3 rounded-lg max-w-md" data-id="element-931">
                        <p className="text-sm" data-id="element-932">
                          Thank you for the interview opportunity. I've
                          confirmed the calendar invitation and I'm looking
                          forward to our conversation on Thursday!
                        </p>
                        <p className="text-xs text-right mt-1 text-gray-500" data-id="element-933">
                          10:35 AM
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="p-4 border-t border-gray-200 bg-white" data-id="element-934">
                  <div className="flex items-center mb-2" data-id="element-935">
                    <button className="text-gray-500 hover:text-gray-700 mr-2" data-id="element-936">
                      <PlusCircle size={18} data-id="element-937" />
                    </button>
                    <div className="flex-1" data-id="element-938">
                      <textarea className="w-full border border-gray-300 rounded-md px-3 py-2 resize-none" placeholder="Type your message..." rows={2} data-id="element-939"></textarea>
                    </div>
                  </div>
                  <div className="flex justify-between items-center" data-id="element-940">
                    <div className="flex items-center space-x-2" data-id="element-941">
                      <button className="text-gray-500 hover:text-indigo-600" data-id="element-942">
                        <Mail size={16} data-id="element-943" />
                      </button>
                      <button className="text-gray-500 hover:text-indigo-600" data-id="element-944">
                        <MessageSquare size={16} data-id="element-945" />
                      </button>
                      <button className="text-gray-500 hover:text-indigo-600" data-id="element-946">
                        <Phone size={16} data-id="element-947" />
                      </button>
                      <button className="text-gray-500 hover:text-indigo-600" data-id="element-948">
                        <Video size={16} data-id="element-949" />
                      </button>
                    </div>
                    <div className="flex items-center space-x-2" data-id="element-950">
                      <button className="text-gray-500 hover:text-indigo-600" data-id="element-951">
                        <Calendar size={16} data-id="element-952" />
                      </button>
                      <button className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors" data-id="element-953">
                        Send
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}
      </div>
    </div>;
};
interface ChannelCardProps {
  icon: React.ReactNode;
  title: string;
  stats: {
    sent: number;
    opened: number;
    rate: number;
  };
  selected: boolean;
  onClick: () => void;
}
const ChannelCard = ({
  icon,
  title,
  stats,
  selected,
  onClick
}: ChannelCardProps) => {
  return <div className={`border rounded-lg p-5 cursor-pointer transition-colors ${selected ? 'border-indigo-600 bg-indigo-50' : 'border-gray-200 hover:border-indigo-400 hover:bg-indigo-50'}`} onClick={onClick} data-id="element-954">
      <div className="flex items-center mb-4" data-id="element-955">
        <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center mr-3" data-id="element-956">
          {icon}
        </div>
        <h3 className="font-medium text-lg" data-id="element-957">{title}</h3>
      </div>
      <div className="space-y-2" data-id="element-958">
        <div className="flex justify-between" data-id="element-959">
          <span className="text-sm text-gray-500" data-id="element-960">Sent</span>
          <span className="font-medium" data-id="element-961">{stats.sent.toLocaleString()}</span>
        </div>
        <div className="flex justify-between" data-id="element-962">
          <span className="text-sm text-gray-500" data-id="element-963">Opened/Answered</span>
          <span className="font-medium" data-id="element-964">{stats.opened.toLocaleString()}</span>
        </div>
        <div className="flex justify-between" data-id="element-965">
          <span className="text-sm text-gray-500" data-id="element-966">Response Rate</span>
          <span className="font-medium text-green-600" data-id="element-967">{stats.rate}%</span>
        </div>
      </div>
    </div>;
};